/* eslint-disable react/display-name */
import React from 'react';
import styled from 'styled-components';

import { reduxConnect } from '../../common';
import { IStoreState, Video } from '../common/interfaces/types';
import { LazyLoadImg } from '../../common/utilities/lazyLoadImg';

interface FeaturedVideosWidgetBodyProps {
    featuredVideos: Video[];
    isFetchingVideos: boolean;
    lastError: Record<string, unknown>;
}

const mapStoreStateToProps = (storeState: IStoreState) => {
    const { video } = storeState || {};
    
    return {
        featuredVideos: video?.videos
    };
};

const mapDispatchToProps = {
};

export const FeaturedVideosWidgetBody = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(({
    featuredVideos }: FeaturedVideosWidgetBodyProps) => {

    const { thumb: featuredVideoThumbnail, t: featuredVideoTitle } = featuredVideos?.[0] || {};

    return (
        <Container>
            <ThumbnailWrapper>
                <LazyLoadImg
                    src={featuredVideoThumbnail}
                    alt='Featured video widget thumbnail'
                    style={styles.imageContainer}
                />
                <LazyLoadImg
                    src='/img/ic-play.png'
                    alt='Featured video widget play button'
                    style={styles.playButton} />
            </ThumbnailWrapper>
            <VideoTitle>
                {featuredVideoTitle}
            </VideoTitle>
        </Container>
    );
});

FeaturedVideosWidgetBody.displayName = 'FeaturedVideosWidgetBody';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 213px;
    position: relative;
    overflow: hidden;
    background-color: #f9f9f9;
    border-bottom-right-radius: 2px;
    border-bottom-left-radius: 2px;
`;

const ThumbnailWrapper = styled.div`
    width: 100%;
    align-items: center;
    justify-content: center;
    display: flex;
    background-color: #000000;
    position: relative;
    width: 100%;
    height: 168px;
`;

const VideoTitle = styled.div`
    background-color: #F9F9F9;
    color: #555555;
    font-size: 14px;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 4px;
    font-weight: 400;
`;

const styles = {
    imageContainer: {
        backgroundSize: 'contain',
        width: 300,
        height: 168
    },
    playButton: {
        position: 'absolute',
        left: 16,
        bottom: 14,
        width: 40,
        height: 40
    }
};
